export class NavMobile {
    mobileTrigger: HTMLElement;
    mobileMenu: HTMLElement;
    constructor(public bodyElement: any) {
        this.mobileTrigger = document.getElementById('mobileTrigger') as HTMLElement;
        this.mobileMenu = document.getElementById('nav-mobile') as HTMLElement;
        let mobileSubnavTriggers = [].slice.call(document.getElementsByClassName('has-sub'));
        if (this.mobileTrigger) {
            this.mobileTrigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.mobileMenu.classList.toggle('open');
                this.mobileTrigger.classList.toggle('open');
                this.bodyElement.classList.toggle('nav-open');
                this.mobileMenu.classList.remove('nav-closed');
            });
            mobileSubnavTriggers.forEach((mobileSubnavTrigger) => {
                var subnavToOpen = mobileSubnavTrigger.querySelector('ul');
                subnavToOpen.classList.add('closed');
                mobileSubnavTrigger.addEventListener('click', (e) => {
                    this.closeOtherPanel(subnavToOpen);
                    this.togglePanel(mobileSubnavTrigger, subnavToOpen);
                });
            });
        }
    }
    closeNav() {
        if (this.mobileMenu.classList.contains('open')) {
            this.mobileTrigger.click();
        }
    }
    closeOtherPanel(newSubNav) {
        let openParent = this.mobileMenu.querySelector('.has-sub.open');
        if (openParent) {
            let openPanel = openParent.querySelector('.open');
            if (openPanel != newSubNav) {
                this.togglePanel(openParent, openPanel);
            }
        }
    }
    togglePanel(parent, panel) {
        parent.classList.toggle('open');
        panel.classList.toggle('closed');
        panel.classList.toggle('open');
        if (panel.classList.contains('open')) {
            panel.setAttribute('aria-hidden', 'false');
        }
        else {
            panel.setAttribute('aria-hidden', 'true');
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/nav-mobile.ts